import {HttpErrorResponse,HttpHeaders,HttpResponse} from '@angular/common/http';
import {Component,OnDestroy,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService,JhiEventManager,JhiParseLinks} from 'ng-jhipster';
import {BsModalRef,ModalDirective} from 'ngx-bootstrap';
import {Subscription,forkJoin} from 'rxjs';
import {Principal} from 'src/app/core';
import {ITEMS_PER_PAGE} from 'src/app/shared/constants/pagination.constants';
import {ActiveStatus} from 'src/app/shared/model/address-my-suffix.model';
import {IUnderwriterInsurerMySuffix} from 'src/app/shared/model/underwriter-insurer-my-suffix.model';
import {IUnderwriterMySuffix} from 'src/app/shared/model/underwriter-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {RoleUtil} from 'src/app/shared/util/role-util';
import {DelegationMySuffixService} from '../underwriter-insurer-my-suffix/delegation-my-suffix.service';
import {UnderwriterInsurerMySuffixService} from '../underwriter-insurer-my-suffix/underwriter-insurer-my-suffix.service';
import {IDelegation} from './../../shared/model/delegation.model';





declare var $:any;
@Component({
    selector: 'jhi-underwriter-my-suffix-detail',
    templateUrl: './underwriter-my-suffix-detail.component.html'
})
export class UnderwriterMySuffixDetailComponent implements OnInit,OnDestroy {
    
    @ViewChild('delegationStatusModel') delegationStatusModel: ModalDirective;
    @ViewChild('delegationDeleteModel') delegationDeleteModel: ModalDirective;

    underwriter: IUnderwriterMySuffix;

    currentAccount: any;
    underwriterInsurers: IUnderwriterInsurerMySuffix[];
    error: any;
    success: any;
    eventSubscriber: Subscription;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    searchText: string;
    searchTextDelegation: string;
    flag: boolean;
    isShowPastHistory: boolean;
    isShowFutureHistory: boolean;
    delegations: IDelegation[] = [];
    undInsId: number;
    modalTitle: string = 'Confirm operation';
    modalContent: string;
    status: string = '';
    showActiveModel: boolean = false;

    public readonly RoleUtil = RoleUtil;

    constructor(
        private activatedRoute: ActivatedRoute,
        private underwriterInsurerService: UnderwriterInsurerMySuffixService,
        private parseLinks: JhiParseLinks,
        private jhiAlertService: JhiAlertService,
        public principal: Principal,
        private router: Router,
        private eventManager: JhiEventManager,
        private languageChangeService: LanguageChangeService,
        private delegationService: DelegationMySuffixService
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data.pagingParams.page;
            this.previousPage = data.pagingParams.page;
            this.reverse = data.pagingParams.ascending;
            this.predicate = data.pagingParams.predicate;
        });
                this.languageChangeService.refreshLanguage();
        this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            if (paramMap.get('size')) {
                this.itemsPerPage = paramMap.get('size')
            }
            const refresh = paramMap.get('refresh');
            if (refresh) {
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
    }

    ngOnInit() {
        this.principal.sortColumn = "priority";
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        this.activatedRoute.data.subscribe(({ underwriter }) => {
            this.underwriter = underwriter;
            console.log('### ', this.underwriter);
        });

        this.loadAll();
        this.principal.identity().then(account => {
            this.currentAccount = account;
        });

        this.loadDelegations();

        this.registerChangeInUnderwriterInsurers();
    }

    previousState() {
        window.history.back();
    }
    get authority() {
        return this.principal.userIdentity.authorities[0];
    }

    loadAll() {
        this.underwriterInsurerService
            .queryWithUId(this.underwriter.id, {
                page: this.page - 1,
                size: this.itemsPerPage,
                sort: this.sort()
            })
            .subscribe(
                (res: HttpResponse<IUnderwriterInsurerMySuffix[]>) => this.paginateUnderwriterInsurers(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res.message)
            );
    }
    onChange(value) {
        this.page = 0;
        this.itemsPerPage = value
        this.loadAll();
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        if (this.searchText) {
            this.searchItems();
            this.flag = true;
        } else {
            this.router.navigate(['/data-management/underwriter/',this.underwriter.id,'/view'], {
                queryParams: {
                    page: this.page,
                    size: this.itemsPerPage,
                    sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                }
            });
            this.loadAll();
        }
    }

    clear() {
        this.page = 0;
        this.router.navigate([
            '/data-management/underwriter-insurer-my-suffix',
            {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        ]);
        this.loadAll();
    }

    ngOnDestroy() {
        if (this.eventSubscriber) {
            this.eventManager.destroy(this.eventSubscriber);
        } 
        this.jhiAlertService.clear()
    }

    trackId(index: number, item: IUnderwriterInsurerMySuffix) {
        return item.id;
    }

    registerChangeInUnderwriterInsurers() {
        this.eventSubscriber = this.eventManager.subscribe('underwriterInsurerListModification', response => this.loadAll());
    }

    sort() {
        const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    actionOrder = {
        [ActiveStatus.ACTIVE] : 1,
        [ActiveStatus.IN_ACTIVE] : 2,
    };

    private paginateUnderwriterInsurers(data: IUnderwriterInsurerMySuffix[], headers: HttpHeaders) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
        this.queryCount = this.totalItems;
        this.underwriterInsurers=data;
        this.underwriterInsurers.forEach(element => {
        
            element.otherUmrs.sort((a, b) => b.year - a.year);
            element.otherUmrs.sort((a,b) => this.actionOrder[a.activeStatus] - this.actionOrder[b.activeStatus])
        });
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    searchItems() {
        console.log(this.underwriter.id);
        let searchData = this.searchText.trim();
            if ( searchData && searchData.length>0) {
                let pNo = 0;
                let size = 20;
                if (this.flag === true) {
                    pNo = this.page - 1;
                    size = this.itemsPerPage;
                    this.flag = false;
                }
                this.underwriterInsurerService
                    .searchQuery(this.searchText, '/search', this.underwriter.id, {
                        page: pNo,
                        size: size,
                        sort: this.sort()
                    })
                    .subscribe(
                        (res: HttpResponse<IUnderwriterInsurerMySuffix[]>) => this.paginateUnderwriterInsurers(res.body, res.headers),
                        (res: HttpErrorResponse) => this.onError(res.message)
                    );
            } else {
                this.loadAll();
            }
    }

    // global modal open and close event
    bsModalRef: BsModalRef;

    openInformationModel(mainObject) {
        // if (mainObject.id !== null && mainObject.id !== undefined) {
        //     let form_data = {
        //         masterId: mainObject.id,
        //         informationType: InformationType.UNDERWRITER_INSURER.valueOf()
        //     }
        //     this.informationModelService.fetchExistedInformationDetailsByType(form_data).subscribe(response => {
        //         const resBody = response.body;
        //         if (resBody && resBody.length > 0) {
        //             const initialState = {
        //                 isUpdateType: false,
        //                 mainList: resBody,
        //             };
        //             this.bsModalRef = this.modalService.show(InformationModelComponent, { initialState, class: "modal-lg" });
        //             this.bsModalRef.content.onClose.subscribe(result => {
        //                 console.log(result);
        //             });
        //         } else {
        //             this.router.navigate(['/data-management', { outlets: { popup: 'underwriter-insurer-my-suffix/' + mainObject.id + '/delete' } }]);
        //         }
        //     });
        // }

        forkJoin([this.underwriterInsurerService.checkForUnderwriterInsurerInPolicies(mainObject.id),this.delegationService.checkForUnderwriterInsurerInDelegations(mainObject.id)])
            .subscribe(resp => {
                let policy:any=resp[ 0 ];
                let delg:any=resp[ 1 ];
                let msg='Underwriter Insurer is present in';
                let isPresent=false;
                if((policy&&policy.body&&policy.body.payload&&policy.body.payload.length>0)) {
                    msg=msg+" policies "+policy.body.payload;
                    isPresent=true;
                }
                if(delg&&delg.body&&delg.body.payload&&delg.body.payload.length>0) {
                    msg=msg+" "+(isPresent? " and in delegations "+delg.body.payload:" delegations "+delg.body.payload);
                    isPresent=true;
                }

                if(isPresent) {
                    this.jhiAlertService.error(msg);
                } else {
                    this.openActivateModal('InActivate',mainObject.id)
                }
        });
    }

    // history
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;

    parentHistoryToggle = false;
    parentFutureHistoryToggle=false;
    
    currentDelegation;

    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

    viewHistoryUN(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Underwriter (' + Obj.name + ') History';
        this.historyType = "UNDERWRITERS_AUDIT";
        this.historyId = Obj.id;
    }

    viewHistoryUI(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Underwriter Representing Insurer (' + Obj.insurancecompany.name + ') History';
        this.historyType = "UNDERWRITER_INSURER_AUDIT";
        this.historyId = Obj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');
    }

    viewFutureHistoryUI(Obj) {
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Underwriter Representing Insurer (' + Obj.insurancecompany.name + ') Future Records';
        this.historyType = "UNDERWRITER_INSURER_AUDIT";
        this.historyId = Obj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');

    }

    viewFutureHistoryUN(Obj) {
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Underwriter (' + Obj.name + ') Future Records';
        this.historyType = "UNDERWRITERS_AUDIT";
        this.historyId = Obj.id;
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }

    searchDelegationItems() {
        console.log(this.underwriter.id);

        if (this.searchTextDelegation) {
            let pNo = 0;
            let size = 20;
            if (this.flag === true) {
                pNo = this.page - 1;
                size = this.itemsPerPage;
                this.flag = false;
            }
            this.delegationService.searchQuery(this.searchTextDelegation, '/search', this.underwriter.id, {
                    page: pNo,
                    size,
                    sort: this.sort()
                })
                .subscribe(
                    (res: HttpResponse<IDelegation[]>) => this.paginateDelegations(res.body, res.headers),
                    (res: HttpErrorResponse) => this.onError(res.message)
                );
        } else {
            this.loadDelegations();
        }
    }

    loadDelegations() {
        this.delegationService.query( {
                page: this.page - 1,
                size: this.itemsPerPage,
                sort: this.sort()
            },this.underwriter.id,)
            .subscribe(
                (res: HttpResponse<IDelegation[]>) => this.paginateDelegations(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res.message)
            );
    }

    private paginateDelegations(data: IDelegation[], headers: HttpHeaders) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
        this.queryCount = this.totalItems;
        this.delegations = data;
    }

    openInformationModelForDelegation(mainObject) {
        this.currentDelegation = mainObject;
        this.delegationStatusModel.show();
        // this.router.navigate(['/data-management',{outlets: {popup: 'delegation-my-suffix/'+mainObject.id+'/delete'}}]);
    }
    
    hideInformationModelForDelegation() {
        this.currentDelegation = null;
        this.delegationStatusModel.hide();
        // this.router.navigate(['/data-management',{outlets: {popup: 'delegation-my-suffix/'+mainObject.id+'/delete'}}]);
    }

    proceedForChangeDelegationStatus(deleg) {
        this.delegationService.changeDelegationStatus(deleg.id).subscribe(res => {
            this.hideInformationModelForDelegation();
            this.loadDelegations();
        },error=> {this.hideInformationModelForDelegation()});
    }

    checkForEditAndRedirect(delegationId) {
        // check in policies if this delegation is present
        this.delegationService.checkForDelegations(delegationId).subscribe(res => {
            if(res && res.body && res.body.payload && res.body.payload.length==0) {
                this.router.navigate(['/data-management/underwriter/delegation',this.underwriter.id,delegationId,'edit']);
            } else {
                let policies: string=' ';
                res.body.payload.forEach(pol => policies=policies+pol.policyNo+",");
                policies.slice(policies.length-1,policies.length);
                this.jhiAlertService.error('Delegation can not be edited as its part of polices :: '+policies);
            }
        });
    }

    viewHistoryDelegation(Obj) {
        this.parentHistoryToggle=true;
        if(Obj.delegationNumber) {
            this.historyTitle = 'Delegation (' + Obj.delegationNumber + ') History';
        } else {
            this.historyTitle = 'Delegation History';
        }
        this.historyType = "DELEGATION_AUDIT";
        this.historyId = Obj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');
    }

    openDeletionModelForDelegation(deleg) {
        this.currentDelegation=deleg;
        this.delegationDeleteModel.show();
        // this.router.navigate(['/data-management',{outlets: {popup: 'delegation-my-suffix/'+mainObject.id+'/delete'}}]);
    }

    proceedForDeleteDelegation(deleg) {
        this.delegationService.deleteDelegation(deleg.id).subscribe(res => {
            this.hideDeleteModal();
            this.loadDelegations();
        },error=> { this.hideDeleteModal()});
    }

    hideDeleteModal() {
        this.delegationDeleteModel.hide();
    }

    openActivateModal(status, undInsId) {
        this.showActiveModel = true;
        this.undInsId = undInsId;
        if (status == 'ACTIVATE') {
            this.modalContent = 'Are you sure you want to activate this Underwriter Representing Insurer?'
            this.status = 'ACTIVE';
        } else {
            this.modalContent = 'Are you sure you want to In-activate this Underwriter Representing Insurer?'
            this.status = 'IN_ACTIVE'
        }
    }

    changeunderwriterInsurerStatus() {
        if (this.undInsId) {
            this.underwriterInsurerService.delete(this.undInsId).subscribe(response => {
                if (this.status == 'ACTIVE') {
                    this.jhiAlertService.success('The Underwriter Representing Insurer has been activated successfully')
                } else {
                    this.jhiAlertService.success('The Underwriter Representing Insurer has been de-activated successfully')
                }
                this.loadAll();
            });
        }
    }

    closeActiveModels(e: boolean) {
        this.showActiveModel = e;
    }
}
